import React, { useState, useCallback } from "react";
import TextInput from "_c/form/TextInput";
import debounce from "lodash/debounce";
import PT from "prop-types";
import s from "styled-components";

const StyledInput = s(TextInput)`
  margin-bottom: 15px;
`;

const ServicesFilter = (props) => {
  const [value, setValue] = useState(props.value);
  const title = props.t("common:search_service");
  const updateStore = useCallback(
    debounce((value) => {
      props.onChange(value);
    }, 250),
    [props.onChange]
  );
  const onChange = ({ target }) => {
    const value = target.value;
    setValue(value);
    updateStore(value);
  };
  return (
    <StyledInput
      value={value}
      onChange={onChange}
      placeholder={title}
      aria-label={title}
    />
  );
};
ServicesFilter.propTypes = {
  value: PT.string,

  t: PT.func.isRequired,
  onChange: PT.func.isRequired,
};

export default ServicesFilter;
